import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';

interface ArrowProps {
  className: string;
  isExpanded: boolean;
  ariaControls: string;
  onClick: () => void;
}

export const ExpandableArrowIcon: React.FC<ArrowProps> = (props) => {
  const iconProps = {
    className: props.className,
    'data-testid': 'iconExpanded' + props.isExpanded,
    'aria-controls': props.ariaControls,
    'aria-haspopup': true,
    onClick: props.onClick,
  };
  return props.isExpanded ? (
    <IndeterminateCheckBoxOutlinedIcon aria-expanded="true" {...iconProps} style={{ width: '0.6em' }} />
  ) : (
    <AddBoxRoundedIcon aria-expanded="false" {...iconProps} style={{ width: '0.6em' }} />
  );
};
